// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-frame[data-v-26b85f2a]{border:1px solid #0ff;background:rgba(0,0,0,.8);height:260px;width:260px;padding:0;font:11pt Courier Prime}.d-frame .d-title[data-v-26b85f2a]{height:24px;background:#0ff;color:#000;padding-top:5px;padding-left:5px;padding-right:5px}.d-frame .d-title .close-btn[data-v-26b85f2a]{float:right;margin:-4px}.d-frame .d-body[data-v-26b85f2a]{text-align:center;color:#ed1d25;padding:20px;padding-top:100px}", ""]);
// Exports
module.exports = exports;
